function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.5 0.5H2.5C1.90326 0.5 1.33097 0.737053 0.90901 1.15901C0.487053 1.58097 0.25 2.15326 0.25 2.75V19.25C0.25 19.8467 0.487053 20.419 0.90901 20.841C1.33097 21.2629 1.90326 21.5 2.5 21.5H11.5C12.0967 21.5 12.669 21.2629 13.091 20.841C13.5129 20.419 13.75 19.8467 13.75 19.25V2.75C13.75 2.15326 13.5129 1.58097 13.091 1.15901C12.669 0.737053 12.0967 0.5 11.5 0.5ZM12.25 19.25C12.25 19.4489 12.171 19.6397 12.0303 19.7803C11.8897 19.921 11.6989 20 11.5 20H2.5C2.30109 20 2.11032 19.921 1.96967 19.7803C1.82902 19.6397 1.75 19.4489 1.75 19.25V2.75C1.75 2.55109 1.82902 2.36032 1.96967 2.21967C2.11032 2.07902 2.30109 2 2.5 2H11.5C11.6989 2 11.8897 2.07902 12.0303 2.21967C12.171 2.36032 12.25 2.55109 12.25 2.75V19.25ZM8.125 4.625C8.125 4.8475 8.05902 5.06501 7.9354 5.25002C7.81179 5.43502 7.63609 5.57922 7.43052 5.66436C7.22495 5.74951 6.99875 5.77179 6.78052 5.72838C6.56229 5.68498 6.36184 5.57783 6.2045 5.4205C6.04717 5.26316 5.94002 5.06271 5.89662 4.84448C5.85321 4.62625 5.87549 4.40005 5.96064 4.19448C6.04578 3.98891 6.18998 3.81321 6.37498 3.6896C6.55999 3.56598 6.7775 3.5 7 3.5C7.29837 3.5 7.58452 3.61853 7.79549 3.8295C8.00647 4.04048 8.125 4.32663 8.125 4.625Z",
  fill: "currentcolor"
});

const SvgMobile = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 14 21",
  fill: "none",
  ref: svgRef
}, props), _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMobile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mobile.edeed4ed.svg";
export { ForwardRef as ReactComponent };